<div class="row mb">
  <div class="col col-md-12">
    <pr-input-column
      label="Evaluation de votre revenus nets annuel"
      [derrors]="derrors"
      [isDefault]="false"
    >
      <input formControlName="distributionEvaluationIncome" type="text" />
    </pr-input-column>
  </div>
</div>
@if (error && derrors) {
  <info [option]="optionInfo1">
    {{ error.message }}
  </info>
}

<distribution-assets-income
  formArrayName="distributionAssetsIncome"
  [derrors]="derrors"
></distribution-assets-income>
